/**
 * The attributes a rendered document tags its regions with, so a builder can
 * map a click in the document back to the part of the entity it came from. A
 * Liquid template spells these literally, so a template test asserts its output
 * against them.
 *
 * Separate from `SELECTION_CONTROL_ATTRIBUTES` in `./selection`: those identify
 * what a Customer is choosing, these identify what a Provider can edit.
 */
export const DOCUMENT_REGION_ATTRIBUTES = {
  sectionKey: 'data-section-key',
  lineItemId: 'data-item-id',
} as const;
